import { CareerBuilderEdgeSearch } from 'wisestep-api';

import BasicSearchForm from '../../types/IBasicSearchForm';
import ICareerBuilderAdvanceSearch from '../types/ICareerBuilderEdgeAdvanceSearch';

const constructFacetValue = (data: any) => {
  const initialValue = `${data.filterBy ?? ' ResumeModified'}:${data.lastActive}`;

  return Object.entries(data ?? {})
    .reduce((cumm, item) => {
      const [key, value] = item;
      let res = '';
      if (Array.isArray(value)) {
        res = value
          .map((el) => {
            if (key === 'locations') {
              return `${getValue(key)}: ${el.city},${el.stateCode},${el.country}`;
            } else {
              return `${getValue(key)}:"${el}"`;
            }
          })
          .join(' ');
      }
      if (res) {
        cumm = cumm + ' ' + res;
      }
      return cumm;
    }, initialValue)
    .trim();
};

const getValue = (key: string) => {
  return key === 'JobTitle' ? 'CaroteneV3Title' : key;
};

export default function (values: BasicSearchForm & ICareerBuilderAdvanceSearch) {
  let orderBy = 'Score';
  let sortDir = 'DESC';
  if (values.sort) {
    switch (values.sort) {
      case 'relevancyMost':
        orderBy = 'Score';
        sortDir = 'DESC';
        break;
      case 'relevancyLeast':
        orderBy = 'Score';
        sortDir = 'ASC';
        break;
      case 'profileMost':
        orderBy = 'ProfileCompleteness';
        sortDir = 'DESC';
        break;
      case 'profileLeast':
        orderBy = 'ProfileCompleteness';
        sortDir = 'ASC';
        break;
      case 'engineMost':
        orderBy = 'SearchEngineRelevance';
        sortDir = 'DESC';
        break;
      case 'engineLeast':
        orderBy = 'SearchEngineRelevance';
        sortDir = 'ASC';
        break;
      case 'modifiedLatest':
        orderBy = 'ResumeModified';
        sortDir = 'DESC';
        break;
      case 'modifiedOldest':
        orderBy = 'ResumeModified';
        sortDir = 'ASC';
        break;
      case 'lastSeenLatest':
        orderBy = 'LatestSeenEvidence';
        sortDir = 'DESC';
        break;
      case 'lastSeenOldest':
        orderBy = 'LatestSeenEvidence';
        sortDir = 'ASC';
        break;
      default:
    }
  }

  const query: CareerBuilderEdgeSearch = {
    accountId: values.accountId,
    pageNumber: values.page,
    page: values.page,
    orderBy: orderBy,
    searchPattern: values.searchPattern,
    radius: `${values?.distance ?? 0}`,
    freshnessInDays: '',
    query: '',
    sort: orderBy,
    sortDir: sortDir,
    keywords: '',
    applyLastActivity: null,
    jobTitle: '',
    company: '',
    country: '',
    facetFilter: '',
    locations: [],
    includeFacets: true,
    includeProfiles: true,
  };

  query.facetFilter = constructFacetValue(values);
  query.locations = values?.locations?.map((loc) => loc.city + ', ' + loc.stateCode) ?? [];

  if (values.jobTitle) {
    query.jobTitle = values.jobTitle;
  }

  if (values.query) {
    query.query = values.query;
  }

  if (values.lastActive) {
    query.freshnessInDays = values.lastActive;
  }
  return query;
}
